import "./CompanyNewRelatedStyles.scss";
const companyNewRelated = () => {
    //
};
export { companyNewRelated };
